import PlatformApi from './_platformApi';
import httpClient from '@/apis/base/httpclient';

class ApplicationApi extends PlatformApi {
  constructor() {
    super();
  }

  controllerName = 'Applications';

  /**
   * lấy dữ liệu danh sách các ứng dụng lên launcher
   * vqphong - 24/04/2025
   */
  getListApps() {
    const request = {
      url: `${this.getAPIUrl()}/data`,
    };
    return httpClient.getAsync(request);
  }
  getRoleApps() {
    const request = {
      url: `${this.getAPIUrl()}/role-app`,
    };
    return httpClient.getAsync(request);
  }
  /**
   * Lấy thông tin ứng dụng theo app_code
   * tbngoc 27.05.2025
   */
  getAppInfo(payload) {
    const request = {
      url: `${this.getAPIUrl()}/application`,
      data: payload,
    };
    return httpClient.getAsync(request);
  }
  /**
   * Kiểm tra xem có đã hoàn thành getting started chưa
   * ndquan1 05.08.2025
   */
  isGettingStarted() {
    const request = {
      url: `${this.getAPIUrl()}/is-getting-started`,
    };
    return httpClient.getAsync(request);
  }

  /**
   * Kiểm tra xem có đã hoàn thành getting started chưa
   * ndquan1 05.08.2025
   */
  isCompleteGettingStarted(appCode, tenantId, budgetCode, applicationType) {
    const params = new URLSearchParams();
    params.append('appCode', appCode);
    params.append('tenantId', tenantId);
    if (budgetCode) params.append('budgetCode', budgetCode);
    if (applicationType) params.append('applicationType', applicationType);
    const request = {
      url: `${this.getAPIUrl()}/check-setup-status?${params.toString()}`,
    };
    return httpClient.getAsync(request);
  }

  isMultipleOrganizationCompleteGettingStarted(appCode, tenantId) {
    const request = {
      url: `${this.getAPIUrl()}/check-multiple-organization-setup-status?appCode=${appCode}&tenantId=${tenantId}`,
    };
    return httpClient.getAsync(request);
  }

  /**
   * Lấy danh sách ứng dụng đã mua mới
   * ndquan1 19.08.2025
   */
  getRegisterApps() {
    const request = {
      url: `${this.getAPIUrl()}/register-apps`,
    };
    return httpClient.getAsync(request);
  }
  /**
   *
   * @returns lấy danh sách ứng dụng mua mới và nâng cấp
   */
  getCustomApplications() {
    const request = {
      url: `${this.getAPIUrl()}/custom-sub-tenant-app`,
    };
    return httpClient.getAsync(request);
  }
  /**
   * Lấy trạng thái đã mua các app riêng lẻ từ trước hay chưa
   * vqphong - 04/08/2025
   */
  getAllocateStatusApps() {
    const request = {
      url: this.getAPIUrl() + '/allocate-status-apps',
    };

    return this.getAsync(request);
  }

  /**
   * Kiểm tra xem user hiện tại có quyền AdminSystem không
   * CreatedBy: AI Assistant 19.01.2026
   */
  hasAdminSystemRole() {
    const request = {
      url: `${this.getAPIUrl()}/has-admin-system-role`,
    };
    return httpClient.getAsync(request);
  }

  /**
   * Generate secure navigation URL với signature từ backend
   * @param {string} appCode - Application code
   * @param {boolean} useNonce - Có sử dụng nonce không (default: true)
   * @param {string} departmentCode - Mã đơn vị (optional, dành cho iGOV)
   * @returns {Promise<Object>} { url, nonce?, timestamp }
   */
  generateNavigationUrl(appCode, useNonce = true, departmentCode = null) {
    const request = {
      url: `${this.getAPIUrl()}/generate-navigation-url`,
      data: {
        appCode,
        useNonce,
        departmentCode,
      },
    };
    return httpClient.postAsync(request);
  }

  validateNavigationSignature(param) {
    const request = {
      url: `${this.getAPIUrl()}/validate-navigation-signature`,
      data: param,
    };
    return httpClient.postAsync(request);
  }
}

export default new ApplicationApi();
